/* eslint-disable import/no-anonymous-default-export */
export default {
  "project.new": "New project",
  "project.edit": "Edit project",
  "project.delete": "Delete project",
  "project.add.title": "Create a new project",
  "project.update.title": "Update the project",
  "project.name": "Project name",
  "project.description": "Project description",
  "project.details": "Details",
  "project.apply": "Apply",
  "project.name.message": "Please enter the project name",
  "project.description.message": "Please enter the project description",
  "project.stage": "Status",
  "project.stage.message": "Please select a status",
  "project.workNumber": "Project code",
  "project.workNumber.message": "Please enter the project code",
  "project.workNumber.exists":
    "A project with the same code already exists. Do you want to register it anyway?",
  "project.revision": "Accepted revision style",
  "project.revision.styles": "Allowed revision styles",
  "project.revision.message": "Select a revision style",
  "project.revision.numeric": "Numeric (Ex.: -R00; -R36; -R87)",
  "project.revision.doubleNumeric":
    "Double Numeric (Ex.: -R00.00; -R00.01; -R01.00)",
  "project.revision.alphabetical": "Alphabetical (Ex.: -RA; -RY; -RAG)",
  "project.revision.alert":
    "The revision style cannot be changed after project creation.",
  "project.link": "Link",
  "project.forum": "Forum",
  "project.company": "Company",
  "project.avatar": "Avatar",
  "project.form.data": "Project data",
  "project.form.access": "Project access",
  "project.company.message": "Please select a company",
  "project.already.created":
    "Project already created, please choose another name",

  "project.stage.IN PROGRESS": "In progress",
  "project.stage.INACTIVE": "Inactive",
  "project.stage.DELIVERED": "Delivered",
  "project.stage.CHANGING": "Changing",

  "project.stage.mode.message": "Select a Status",

  "project.emptyDataMessage.message": "Hello, there is nothing here yet.",
  "project.emptyDataMessage.instructions":
    "You can start by creating a new project!",
  "project.emptyDataMessage.newProject": "+ New project",
};
